const statusFaq = {
  publicado: { nome: "Publicado", cor: "success" },
  despublicado: { nome: "Despublicado", cor: "error" },
  rascunho: { nome: "Rascunho", cor: "grey" },
};

export const nomeStatus = status => (statusFaq[status] || { nome: "Status desconhecido" }).nome;
export const corStatus = status => (statusFaq[status] || { cor: "grey" }).cor;
